import LegalShell, { LegalSection } from './LegalShell';

export default function TermsPage() {
  return (
    <LegalShell testId="terms-page" eyebrow="Legal" title="Terms & Conditions">
      <LegalSection n="1" title="About this portal">
        <p>
          This portal is operated by PNC UNIQUE LTD (&ldquo;PNC&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;)
          to issue, sign and store contractor agreements electronically — including the Contract for
          Services, weekly invoice creation opt-ins, insurance cover opt-ins, and health &amp; safety
          acknowledgements. By using the portal you agree to these terms.
        </p>
      </LegalSection>

      <LegalSection n="2" title="Invitation-only access">
        <ul>
          <li>Access is by personal invitation only. Each signing link contains a single-use token cryptographically linked to the email address the invitation was sent to.</li>
          <li>Signing links must not be shared, transferred or re-used. Links expire automatically after 30 days.</li>
          <li>If your link has expired or been used, contact PNC HR to request a new invitation.</li>
        </ul>
      </LegalSection>

      <LegalSection n="3" title="Electronic signatures">
        <p>
          By drawing your signature and submitting an agreement through this portal, you consent to
          conducting the transaction electronically. Electronic signatures given through this portal are
          intended to be legally binding and enforceable in the same way as handwritten signatures, in
          accordance with the Electronic Communications Act 2000 and the UK eIDAS Regulation.
        </p>
        <p>
          Each submission is stamped with the date, time, IP address and browser details of the signer,
          which together form the audit record of the signature.
        </p>
      </LegalSection>

      <LegalSection n="4" title="Your obligations">
        <ul>
          <li>You must provide accurate and complete information, including your legal name and business name.</li>
          <li>You must only sign agreements addressed to you at the email address you control.</li>
          <li>You must read each agreement, Tool Box Talk section and Site Rule in full before confirming acceptance.</li>
          <li>You must not attempt to access, interfere with or reverse-engineer any part of the portal.</li>
        </ul>
      </LegalSection>

      <LegalSection n="5" title="Service opt-ins">
        <p>
          Where you are invited to opt in to a PNC service — such as weekly invoice creation (£2 per week)
          or insurance cover (£5 per week) — the terms and charges of that service are stated on the signing
          page and in the confirmation document generated when you accept. Declining a service request has
          no effect on your existing contract with PNC.
        </p>
      </LegalSection>

      <LegalSection n="6" title="Availability and liability">
        <p>
          We aim to keep the portal available at all times but do not guarantee uninterrupted access.
          We may suspend the portal for maintenance or security reasons. Nothing in these terms limits or
          excludes liability for fraud, or for death or personal injury caused by negligence. Subject to
          that, PNC is not liable for indirect or consequential loss arising from use of the portal.
        </p>
      </LegalSection>

      <LegalSection n="7" title="Privacy">
        <p>
          Personal data submitted through the portal is handled in accordance with our{' '}
          <a href="/privacy">Privacy Notice</a> and{' '}
          <a href="/security">Security &amp; Data Retention</a> policy.
        </p>
      </LegalSection>

      <LegalSection n="8" title="Governing law">
        <p>
          These terms, and any agreement signed through the portal (unless that agreement states otherwise),
          are governed by the laws of England and Wales, and the courts of England and Wales have exclusive
          jurisdiction.
        </p>
      </LegalSection>

      <LegalSection n="9" title="Company identity">
        <p>PNC UNIQUE LTD, registered in England and Wales.</p>
        <p>Registered office: Headlands House, 1 Kings Court, Kettering Parkway, Kettering, Northamptonshire, NN15 6WJ.</p>
        <p>ICO Registration: <strong>ZB865873</strong> &middot; <a href="mailto:admin@pncunique.com">admin@pncunique.com</a> &middot; 0333 090 5024</p>
      </LegalSection>
    </LegalShell>
  );
}
